/* eslint-disable */
import React, { useRef, useState } from "react";
import { Formik, Form } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { Captcha } from "primereact/captcha";

import PageWrapper from "../../PageWrapper";
import InputText from "../../GenericFormikComponents/InputText";
import PrimaryButton from "../../SFUCentralThemedComponents/PrimaryButton";
import Label from "../../Label";
import ProgressSpinnerPR from "../../PrimeReact/ProgressSpinnerPR";

import { validationSchema, initialValues } from "./validationSchema";
import {
  selectError,
  selectAuthStatus,
  postLogin,
  selectScholarshipType,
} from "../../../utils/auth/authSlice";

export default function LoginPage() {
  const scholarshipType = useSelector(selectScholarshipType);
  const error = useSelector(selectError);
  const authStatus = useSelector(selectAuthStatus);
  const dispatch = useDispatch();
  const [reCaptchaVerified, setReCaptchaVerified] = useState(false);
  const [recaptchaResponse, setRecaptchaResponse] = useState("");
  const spinnerStatus = authStatus === "loading";
  const captchaRef = useRef();
  function handleOnClickCaptchaResponse(response) {
    setReCaptchaVerified(true);
    setRecaptchaResponse(response.response);
  }
  function handleOnExpireCaptchaResponse() {
    setReCaptchaVerified(false);
    setRecaptchaResponse("");
  }

  return (
    <PageWrapper>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          values.scholarshipName = scholarshipType;
          values.recaptchaResponse = recaptchaResponse;
          dispatch(postLogin(values));
          window.scrollTo(0, 0);
          setReCaptchaVerified(false);
          captchaRef.current.reset();
        }}
      >
        <Form>
          <div className="p-grid">
            <div className="p-col-12" style={{ marginBottom: "20px" }}>
              <h1>Login</h1>
            </div>
            <div className="p-col-12 p-md-6">
              <Label htmlFor="email">
                <span className="p-col-12 p-col-nogutter">Email Address</span>
                <InputText
                  name="email"
                  placeholder="Enter Email Address"
                  className="p-col-12"
                />
              </Label>
            </div>
            <div className="p-col-12 p-md-6">
              <Label htmlFor="studentId">
                <span className="p-col-12 p-col-nogutter">Student ID</span>
                <InputText
                  name="studentId"
                  placeholder="Enter Student ID"
                  className="p-col-12"
                />
              </Label>
            </div>
            <div className="p-col-12">
              <div className="card">
                <Captcha
                  siteKey="6LePLjwaAAAAALbPJH4vo9XCZwB4jGV5FJ3p0C1B"
                  onResponse={handleOnClickCaptchaResponse}
                  onExpire={handleOnExpireCaptchaResponse}
                  ref={captchaRef}
                />
              </div>
            </div>
            {error ? (
              <div className="p-col-12">
                <div className="p-invalid">{error}</div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="p-grid button-navigation-container">
            <div className="p-col-12">
              <PrimaryButton
                type="submit"
                disabled={!reCaptchaVerified || spinnerStatus}
              >
                Login
              </PrimaryButton>
            </div>
          </div>
        </Form>
      </Formik>

      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
